import { render, staticRenderFns } from "./selectCliente.vue?vue&type=template&id=435885fa"
import script from "./selectCliente.vue?vue&type=script&lang=ts"
export * from "./selectCliente.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports